export default __webpack_public_path__ + "images/87e34e07ffe5d7b9c81bbb3d1baa0bfb-Industry-Medium.woff2";